import { memo } from 'react';
import { MaterialRequisitionItemFormResponse } from '@Types/api/form';
import MaterialTabItem from '../../../View/components/MaterialsTab/MaterialTabItem';

import styles from '../details.module.css';

interface MaterialDetailsProps {
  list: MaterialRequisitionItemFormResponse[];
}

const MaterialDetails: React.FC<MaterialDetailsProps> = ({ list }) => {
  if (!list.length) return null;
  return (
    <div className={styles.details}>
      {list.map((matItem) => (
        <MaterialTabItem
          index={matItem.reqItemId}
          activityCode={matItem.actCode}
          activityName={matItem.actName}
          materialCode={matItem.matCode}
          materialDescription={matItem.matDesc}
          plantCode={matItem.plantCode}
          plantId={matItem.plantId}
          plantName={matItem.plantName}
          ledgerName={matItem.ledgerName}
          ledgerCode={matItem.ledgerCode}
          ledgerId={matItem.ledgerId}
          qty={matItem.reqQty}
          remarks={matItem.transferRemarks}
          resourceCode={matItem.resCode}
          resourceDescription={matItem.resDesc}
          unit={matItem.unitName}
          repeatItem={matItem.repeatForAll}
          key={matItem.reqItemId}
        />
      ))}
    </div>
  );
};

export default memo(MaterialDetails);
